module.exports = __webpack_public_path__ + "img/gatto-musicale.87bc82bc.jpg";